import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormGroup, FormBuilder, AbstractControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { DataService } from 'src/app/blacklist/service/data.service';
import { BackendApiService } from 'src/app/service/backendapi.service';
import { EndpointsService } from 'src/app/service/endpoints.service';

@Component({
  selector: 'app-delete-offer',
  templateUrl: './delete-offer.component.html',
  styleUrls: ['./delete-offer.component.scss']
})
export class DeleteOfferComponent implements OnInit {
  deleteOfferForm: FormGroup;
  loadPage: boolean;
  loadTable = false;
  showTable: boolean;
  reportData: [];
  updateFlag = false;
  submitted = true;
  file: any;
  csvContentDelete: string;
  variable1:any;
  constructor(private spinnerService: Ng4LoadingSpinnerService, private dataService: DataService,
    private formBuilder: FormBuilder, private router: Router,
    private endpointsService: EndpointsService, private dialog: MatDialog,
    private backendApiService: BackendApiService) { }

    ngOnInit(): void {
      this.spinnerService.show();
      sessionStorage.setItem('csvContentDelete','')
      this.createReportForm();
      this.loadPage = true;
    }
    createReportForm() {
      this.deleteOfferForm = this.formBuilder.group({
       // msisdn: [''],
       msisdn: ['', [Validators.maxLength(12),Validators.pattern("^[0-9]*$"), this.countryCodeValidator]],
           // imsi: ['']
      });
    }
    get f() {
      return this.deleteOfferForm.controls;
    }
  
      onSubmit() {
        if(this.deleteOfferForm.get('msisdn').value =='' && sessionStorage.getItem('csvContentDelete') == '')
    {
      alert("Please Provide Msisdn Values");
      return;
    }
    if(this.deleteOfferForm.get('msisdn').value !='' && sessionStorage.getItem('csvContentDelete') != '')
    {
      alert("Please Select Only One Feild");
       let currentUrl = this.router.url;
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = 'reload';
        this.router.navigate([currentUrl]);
      return;
    }
        //console.log(this.csvContent);
        let apiUrl;
        this.submitted = true;
        if(this.deleteOfferForm.invalid)   
        {
          return;
        }
        this.spinnerService.show();
        this.showTable = false;
    
        if(this.deleteOfferForm.get('msisdn').value !=''){
        apiUrl = this.endpointsService.URL_DELETE_SUBSCRIBER_OFFER +
        '&msisdn=' + this.deleteOfferForm.get('msisdn').value +
        '&OrgId=' + sessionStorage.getItem('userOrgId');
        }
        else{
          var abc = sessionStorage.getItem('csvContentDelete');
          // var xyz = abc.split(/[,\n]+\s+/g).join(',');
          // console.log(xyz);
          this.formateString(abc);
        apiUrl = this.endpointsService.URL_DELETE_SUBSCRIBER_OFFER +
        '&msisdn=' + this.variable1 +
        '&OrgId=' + sessionStorage.getItem('userOrgId');
        
        }
        this.backendApiService.callToApi(apiUrl).subscribe(response =>{
          if(response === null)
           { return;}
           else{
          this.reportData = response;
          alert("MSISDN Deleted Successfully");
        //  this.showTable = true;
        this.spinnerService.hide();
        let currentUrl = this.router.url;
         this.router.routeReuseStrategy.shouldReuseRoute = () => false;
         this.router.onSameUrlNavigation = 'reload';
         this.router.navigate([currentUrl]);}

        });}
      countryCodeValidator(control: AbstractControl): { [key: string]: boolean } | null {
        if (control.value.length >= 12) {
          let map = new Map();
          map.set('Ghana', '233');
          map.set('Liberia', '231');
          map.set('Guinea-B', '245');
          map.set('Guinea', '224');
          map.set('Benin', '229');
          map.set('CIV', '225');
          map.set('Nigeria', '234');
          map.set('Congo-B', '242');
          map.set('Cameroon', '237');
          let v = control.value + "";
          let countryCode = v.substr(0, 3);
          let country = sessionStorage.getItem('homeCountry').trim();
          
          if (map.get(country)) {
            if (parseInt(countryCode) !== parseInt(map.get(country))) {
              return { 'countryCode': true };
            }
          }
        }
        return null;
      }
  
      
    
      onFileLoad(fileLoadedEvent) {
        const textFromFileLoaded = fileLoadedEvent.target.result;              
        this.csvContentDelete = textFromFileLoaded;     
       // alert(this.csvContentDelete);
        sessionStorage.setItem('csvContentDelete', this.csvContentDelete);
       //this.variable1 = sessionStorage.getItem('csvContent');
    
    }
    
    onFileSelect(input: HTMLInputElement) {
      sessionStorage.setItem('csvContentDelete','')
    
    const files = input.files;
    var content = this.csvContentDelete;    
    if (files && files.length) {
     
     
      const fileToRead = files[0];
      
      const fileReader = new FileReader();
      fileReader.onload = this.onFileLoad;
     
      fileReader.readAsText(fileToRead, "UTF-8");
      this.variable1=this.csvContentDelete;
    }
       
    }
     formateString(abc) {
    
      var strArray = abc.split("\n");
      strArray = strArray.filter((item) => {
        return item !== '';
      });
      console.log(strArray.join(",").split(",,").join(","));
      this.variable1= strArray.join(",").split(",,").join(",");
    }
  
  
  }
